@if (images?.length) {
  <app-image-carousel [images]="images" [guestDisplay]="guestDisplay" [zoom]="zoom" (handleZoom)="handleZoom($event)"> </app-image-carousel>
}
